<!-- Shared Profile Form Content Template (without footer) -->
<ng-template #profileFormFields>
  @if (profileForm) {
    <form [formGroup]="profileForm">
      <!-- Profile Picture -->
      <div class="flex justify-center mb-8">
        <foxera-profile-input
          [imageUrl]="profileData()?.profileImagePath || null"
          [firstName]="firstName"
          [lastName]="lastName"
          (fileEmployee)="onFileSelected($event)"
          (validationError)="onValidationError($event)"
        />
      </div>

      <!-- Name Fields -->
      <div class="grid gap-6" [ngClass]="isMobile() ? 'grid-cols-1' : 'grid-cols-2'">
        <foxera-input-text
          [config]="{
            label: 'First Name',
            placeholder: 'Enter first name',
            required: true
          }"
          name="firstName"
          id="firstName"
          formControlName="firstName"
        />

        <foxera-input-text
          [config]="{
            label: 'Last Name',
            placeholder: 'Enter last name',
            required: true
          }"
          name="lastName"
          id="lastName"
          formControlName="lastName"
        />
      </div>

      <!-- Contact Fields -->
      <div class="grid gap-6 mt-6" [ngClass]="isMobile() ? 'grid-cols-1' : 'grid-cols-2'">
        <foxera-phone-input
          label="Phone Number"
          name="phoneNumber"
          id="phoneNumber"
          [required]="true"
          formControlName="phoneNumber"
        />

        <foxera-email-input
          [config]="{
            label: 'Email',
            placeholder: 'Enter email',
            required: true,
            disabled: true
          }"
          name="email"
          id="email"
          formControlName="email"
        />
      </div>

      <!-- Date of Birth and Time Format -->
      <div class="grid gap-6 mt-6" [ngClass]="isMobile() ? 'grid-cols-1' : 'grid-cols-2'">
        <foxera-datepicker
          [config]="{
            label: 'Date Of Birth',
            placeholder: 'Select date of birth',
            required: false
          }"
          name="birthdate"
          id="birthdate"
          formControlName="birthdate"
        />

        <foxera-select
          [config]="{
            label: 'Time Format',
            placeholder: 'Select time format',
            options: timeFormatOptions(),
            optionLabel: 'label',
            optionValue: 'value',
            required: true,
            requiredErrorMessage: 'Time format is required.'
          }"
          name="timeFormat"
          id="timeFormat"
          formControlName="timeFormat"
        />
      </div>
    </form>
  }
</ng-template>

<!-- Desktop: Dialog -->
@if (!isMobile()) {
  <foxera-dialog
    [(visible)]="isVisible"
    [title]="'Profile'"
    [isEditMode]="true"
    [showDeleteButton]="false"
    [isSaving]="isSaving"
    (onClose)="close()"
    (onSave)="save()">

    <!-- Form Content -->
    <ng-container *ngTemplateOutlet="profileFormFields" />

  </foxera-dialog>
}

<!-- Mobile: Full Screen Drawer from Right -->
@if (isMobile()) {
  <foxera-drawer-full
    [(visible)]="isVisible"
    [title]="'Profile'"
    [showFooter]="true"
    [isEditMode]="true"
    [showDeleteButton]="false"
    [isSaving]="isSaving"
    (onClose)="close()"
    (onSave)="save()">
    
    <!-- Form Fields -->
    <ng-container *ngTemplateOutlet="profileFormFields" />
    
  </foxera-drawer-full>
}
